var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1FYiZ{position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:1000}._1FYiZ img{width:678px;height:320px}._2mFql{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5)}._3E_sN{display:block;height:24px;width:24px;position:absolute;top:10px;right:10px;background:0 0 url(" + escape(require("./ic_close.png")) + ") no-repeat}", ""]);

// exports
exports.locals = {
	"content": "_1FYiZ",
	"cover": "_2mFql",
	"close": "_3E_sN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_home/Pop/index.css
// module id = 1237
// module chunks = 1